import React, { useEffect, useState } from 'react'
import { seeFollowingList, stopFollow } from '../../actions/friendsActions'
import { connect } from 'react-redux';
import { ReactComponent as OptionsIcon } from '../../img/ic_opciones.svg';
import circle from '../../img/circulogris.png';
import { searchFriends } from '../../actions/searchActions'
import ModalMenu from '../../containers/ModalMenu';
import searchIcon from '../../img/ic__buscador.png'
import inMemoryJWT from '../../auth/inMemoryJwt';

const FollowingList = ({ match, history, seeFollowingList, followingList, searchFriends, searchList, isLoadingSearch, stopFollow, isLoading }) => {

    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            seeFollowingList(match.params.userID)
        })

    }, [])

    const [searchText, setSearchText] = useState("")

    return (
        <div className="background-gray">
            <div className="wrapper-24 container-80">
                <div className="friend-list-container">
                    <div className="wrapper-2 mt-5 mb-5">
                        <div className="friends-count-friend-list">
                            Siguiendo
                            <div className="littleText ml-1 mb-1">{!isLoading && Object.values(followingList).length}</div>
                        </div>
                        <div className="search-friend-list">
                            <div className="search-bar-friends ">
                                <img src={searchIcon} alt="img" className="img-search-bar" />
                                <input className="input-inside-div" onChange={(e) => {
                                    setSearchText(e.target.value)
                                    searchFriends(e.target.value, true, false)
                                }} type="text" placeholder="Buscar..." />
                            </div>
                        </div>
                    </div>
                    {searchText ==="" ?
                        <div className="">
                            {!isLoading && Object.values(followingList).length > 0 ? Object.values(followingList).map(([id,{user,social}]) => {
                                var contentModal = <div className='modal-options'>
                                    <div className="modal-options-social-list">
                                        <div className="row">
                                            <div onClick={() => { stopFollow(user._id) }} className="">Dejar de seguir</div>
                                        </div>
                                    </div>
                                </div>
                                return <div key={user._id} className="content-social-show-list">
                                    {user.picture ? <img alt="img" onClick={() => {
                                        if (!history.location.pathname.includes('Mark'))
                                            history.push('/Profile/' + user._id)
                                    }} className="pointer picture-show-list-social" onError={e => e.target.src = circle} src={user.picture.url ? user.picture.url.small : user.picture}></img> :
                                        <img alt="img" onClick={() => {
                                            if (!history.location.pathname.includes('Mark'))
                                                history.push('/Profile/' + user._id)
                                        }} className="pointer picture-show-list-social" src={circle}></img>
                                    }
                                    <div className="content-name-show-list-social">
                                        <div onClick={() => {
                                            if (!history.location.pathname.includes('Mark'))
                                                history.push('/Profile/' + user._id)
                                        }} className="pointer text-bold">@{user.name}</div>
                                        <div onClick={() => {
                                            if (!history.location.pathname.includes('Mark'))
                                                history.push('/Profile/' + user._id)
                                        }} className="pointer ">{user.name}</div>
                                    </div>
                                    <div className="content-options-show-list-social">
                                        <ModalMenu
                                            contentButton={<OptionsIcon className="black-svg" height="15" width="35" />}
                                            contentModal={contentModal}
                                        />
                                    </div>
                                </div>
                            }) :
                                'Aún no sigues a alguien'}
                        </div>
                        :
                        <div className="">
                            {(!isLoadingSearch && Object.values(searchList).length > 0) ? Object.values(searchList).map((user, index) => {
                                var contentModal = <div className='modal-options'>
                                    <div className="modal-options-social-list">
                                        <div className="row">
                                            <div onClick={() => { stopFollow(user._id) }} className="">Dejar de seguir</div>
                                        </div>
                                    </div>
                                </div>
                                return <div key={user._id} className="content-social-show-list">
                                    {user.picture ? <img alt="img" onClick={() => history.push('/Profile/' + user._id)} className="pointer picture-show-list-social" onError={e => e.target.src = circle} src={user.picture.url ? user.picture.url.small : user.picture}></img> :
                                        <img alt="img" onClick={() => history.push('/Profile/' + user._id)} className="pointer picture-show-list-social" src={circle}></img>
                                    }
                                    <div className="content-name-show-list-social">
                                        <div onClick={() => history.push('/Profile/' + user._id)} className="pointer text-bold">@{user.name}</div>
                                        <div onClick={() => history.push('/Profile/' + user._id)} className="pointer ">{user.name}</div>
                                    </div>
                                    <div className="content-options-show-list-social">
                                        <ModalMenu
                                            contentButton={<OptionsIcon className="black-svg" height="15" width="35" />}
                                            contentModal={contentModal}
                                        />
                                    </div>
                                </div>
                            }) :
                                'No existen resultados para la busqueda'
                            }
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        followingList: state.userInfo.followingList,
        isLoading: state.userInfo.isLoadingFollowingList,
        searchList: state.users.friendSearchList,
        isLoadingSearch: state.users.isLoadingSearchFriendList
    }
}
export default connect(mapStateToProps, { seeFollowingList, searchFriends, stopFollow })(FollowingList)
